import { AirDetailCreate } from './AirDetailCreate'
import { AirDetailEdit } from './AirDetailEdit'
import { AirDetailList } from './AirDetailList'
import { AirDetailShow } from './AirDetailShow'

export { AirDetailCreate, AirDetailEdit, AirDetailList, AirDetailShow }
